import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { cn } from "@/lib/utils";

/* Arbitrage n°14 : le laiton est réservé à l'action principale et à rien
   d'autre. C'est pour cela qu'il n'y a qu'une seule variante « principal ». */
export const stylesBouton = cva(
  "inline-flex items-center justify-center gap-2 rounded-[6px] text-sm font-medium " +
    "transition-colors disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variante: {
        principal: "bg-laiton text-white hover:bg-laiton-fonce",
        secondaire: "border border-filet bg-white text-encre hover:bg-chene-clair/40",
        discret: "text-encre-douce hover:text-encre hover:bg-filet/60",
        sombre: "bg-anthracite text-blanc-casse hover:bg-anthracite-clair",
      },
      taille: {
        // 44 px de haut : la cible tactile minimale recommandée, et le terrain
        // travaille avec des gants.
        normal: "h-11 px-4",
        compact: "h-9 px-3",
      },
    },
    defaultVariants: { variante: "secondaire", taille: "normal" },
  },
);

type Props = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof stylesBouton>;

export function Bouton({ className, variante, taille, ...reste }: Props) {
  return <button className={cn(stylesBouton({ variante, taille }), className)} {...reste} />;
}

/**
 * Un lien qui a l'allure d'un bouton — et qui reste un lien.
 *
 * « Nouveau dossier » ouvre une adresse : c'est une navigation, pas une action.
 * L'envelopper dans un `<button>` produirait un `<a>` dans un `<button>`, que
 * le navigateur ne sait pas rendre et que le clavier ne sait pas parcourir.
 */
export function LienBouton({
  className,
  variante,
  taille,
  ...reste
}: LinkProps & VariantProps<typeof stylesBouton>) {
  return <Link className={cn(stylesBouton({ variante, taille }), className)} {...reste} />;
}
